const storageKey = "merrin.organisation"

export function lastOrganisation(): string | null {
  try {
    return window.localStorage.getItem(storageKey)
  } catch {
    return null
  }
}

export function rememberOrganisation(slug: string): void {
  try {
    window.localStorage.setItem(storageKey, slug)
  } catch {
    return
  }
}

export function forgetOrganisation(slug: string): void {
  try {
    if (window.localStorage.getItem(storageKey) === slug) {
      window.localStorage.removeItem(storageKey)
    }
  } catch {
    return
  }
}
